var exports = {
  "kL": "container__qcj0r_",
  "wx": "header__aOWhon",
  "cy": "author__APDmBh",
  "my": "avatar__mvZmZz",
  "Pp": "avatarImage__dFiuL6",
  "fh": "authorName__g0szwA",
  "V2": "coauthors__0q-wtU",
  "Sg": "opened__Vgb2nB",
  "eu": "editMetadata__ws0CPo",
  "xd": "editHistory__7RHqq5",
  "r9": "editButton__kkP1ND",
  "rf": "body__fphukB",
};

module.exports = exports;
